import { StepState } from '@/enums/step-states';
import { StepType } from '../../../interfaces/enums/step-type';
import IStep from '@/interfaces/step.interface';

export default class CommitStep implements IStep {
	public stepType = StepType.COMMIT;
	public actions: any[] = [];
	public feedbackGiven = false;
	public icon = 'lnr-paper-plane';
	public heading = 'Commit';
	public description = 'Take final decision on which programme to enrol in.';
	public selected = 'true';
	public readyToCompleteText = '';
	public doneCondition(): boolean {
		// some logic here

		return true;
	}

	public stepState(): StepState {
		let allActionsCompleted = false;
		// TODO: connect flag here
		const hasCompletedStep = false;

		if (hasCompletedStep) {
			return StepState.DONE;
		}

		for (const action of this.actions) {
			// eslint-disable-next-line @typescript-eslint/no-unsafe-call
			if (!action.done()) {
				allActionsCompleted = false;
			}
		}

		if (allActionsCompleted && !hasCompletedStep) {
			return StepState.READY_TO_COMPLETE;
		}

		return StepState.IN_PROGRESS;
	}
}
